import { navigate } from "gatsby"
import { LocalStorageUtility } from "../../../../util/localStorageUtility"
// import { ApiService } from "../../../../services/api.service"
// import { Cookies as ReactCookies } from "react-cookie"
// const cookies = new ReactCookies()


/**
 * @function logout - Function to logout the user
 * @param removeCookie - hook to remove cookie
 * @param setState - hook to set Auth context state
 */
export const logout = (removeCookie, setState) => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  
  const targetUrl = sessionStorage.getItem('targetUrl');
  if(targetUrl === "logout") {
    sessionStorage.removeItem("targetUrl");
  } else if(!url.includes("login")){
    sessionStorage.setItem("targetUrl", url);
  }

  setState({
    authenticated: false,
    message: {
      text: "",
      variant: "",
    },
    user: {
      username: "",
      userId: "",
      roleId: "",
    },
    employeeDetails: {
      employeeId: 0,
      employeeName: "",
      employeeNumber: 0,
      employeeNameNumber: "",
    },
    rules: [],
    loading: false,
    aliased: false,
    isAdUser: false,
    position: {},
  })
  // const payload = [
  //   {
  //     TokenDetail: cookies.get("hallenToken")
  //   }
  // ]
  // if(cookies.get("hallenToken")){
  //   ApiService.post(process.env.INVALID_USER, payload).then((res: any) => {
  //     removeCookie("hallenToken", { path: "/" })
  //   })
  // } else {
  removeCookie("hallenToken", { path: "/" })
  // }
  LocalStorageUtility.removeLocalStorage()
  navigate("/login")
}
